import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-confirm-register',
  templateUrl: './confirm-register.component.html',
  styleUrls: ['./confirm-register.component.scss']
})
export class ConfirmRegisterComponent extends SubscriptionBaseComponent implements OnInit {

  faPaperPlane = faPaperPlane;

  email: string;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private uiService: UiService

  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.redirectionAfterConfirmation();
  }

  private redirectionAfterConfirmation(): void {
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 8000);
  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.email.asObservable().subscribe(email => {
        this.email = email;
        this.cdr.detectChanges();
      }, error => {
        this.uiService.openSnackBar(error.error, '');
      })
    );
  }

}
